import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssignTeacherComponent } from '../assign-teacher/assign-teacher.component';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';
import { TeacherReportComponent } from '../teacher-report/teacher-report.component';

@Component({
  selector: 'app-assign-teacher-data',
  templateUrl: './assign-teacher-data.component.html',
  styleUrls: ['./assign-teacher-data.component.scss']
})
export class AssignTeacherDataComponent implements OnInit {
  ExaminerList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  constructor(public umsService: UmsService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.getExaminer();
  }


  addnewrecord() {
    const dialogRef = this.dialog.open(AssignTeacherComponent, {
      width: 'auto',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getExaminer();
    });
  }


  print() { 
     let data = {};
    data['isFinal'] = 1;
    const dialogRef = this.dialog.open(TeacherReportComponent, {
      width: 'auto',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getExaminer();
    });
  }


  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getExaminer();
    // this.keypress()
  }
  getExaminer() {
    this.spinner.show();
    let payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getExaminer(payload).subscribe(res => {
      this.spinner.hide();
      this.ExaminerList = res.data;
      this.totalItems = res.data[0].TotalRecords;
      if (res.status) {

      } else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();

    });
  }
}
